module.exports = __webpack_public_path__ + "static/img/花瓶7.aa5f442.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/reliefVase/imgs/花瓶7.png
// module id = qK4O
// module chunks = 2